module.exports = __webpack_public_path__ + "img/checkmark-sm-gold.1ef8783e.svg";